import { memoizeOneFactory } from 'core/memoizer';
const getter = (visibleColumns, selectedColumns) => visibleColumns
    .map(c => c.id)
    .filter(c => selectedColumns.indexOf(c) !== -1);
export default memoizeOneFactory(getter);
